/* eslint-disable import/prefer-default-export */
import { getDisplayText, getColor } from '../utils'
import { DashboardWidgetData } from '../../../../../features/widget/types'
import { InsightCount } from '../../../../../schemas/action/InsightCountSchema'
import { InsightData } from '../../../../../schemas/action/InsightDataSchema'
import { WordCloudWidgetsType } from '../../types'

const retrieveDataSet = (response: DashboardWidgetData<InsightCount>, topN: number) => {
  const topNDataSet = response?.results?.[0]?.data?.insights?.[0]?.dataset?.map((dataset) => ({
    ...dataset,
    set: dataset.set?.slice(0, topN)
  }))
  const mergedTopNDataset =
    topNDataSet?.flatMap((dataset) =>
      dataset.set!.map((item) => ({ ...item, insightType: dataset.insightType }))
    ) || []
  return mergedTopNDataset
}

const getMaxDataValue = (set: InsightData[]) => Math.max(...set.map((item) => item.value!))

/**
 * convert responses from runsearch to data displayed on table
 * @param searchResponses responses from runsearch
 * @param widgetSetting widget setting
 */
export const convertToTableData = (
  searchResponses: DashboardWidgetData<InsightCount>[],
  widgetSetting: WordCloudWidgetsType,
  emojiNameToDisplayMap: Record<string, string>
) => {
  const rowData =
    searchResponses
      ?.map((response) => {
        const dataSet = retrieveDataSet(response, widgetSetting.topN!)
        const maxVal = getMaxDataValue(dataSet)
        return dataSet.map((item) => {
          const text = getDisplayText(item.name!, widgetSetting.viewOption!, emojiNameToDisplayMap)
          return {
            name: text,
            value: item.value!,
            percentage: item.value! / maxVal,
            key: item.name!,
            colorKey: getColor(widgetSetting.analysisType!, item.insightType!),
            insight: item
          }
        })
      })
      .flat() || []
  if ('minCount' in widgetSetting) {
    return rowData.filter((row) => row.value >= widgetSetting.minCount!)
  }
  return rowData
}
